// import React, { useState } from "react";
// import ShortenUrlForm from "../components/ShortenUrlForm";
// import UrlList from "../components/UrlList";

// const Home = () => { 
//     const [updateList, setUpdateList] = useState(false);

//     const refreshUrls = () => {
//         setUpdateList(!updateList);
//     };

//     return (
//         <div>
//             <h1>Acortador de URLs</h1>
//             <ShortenUrlForm onUrlShortened={refreshUrls} />
//             <UrlList key={updateList} />
//         </div>
//     );
// };

// export default Home;

import React, { useState } from "react";
import ShortenUrlForm from "../components/ShortenUrlForm"; 
import UrlList from "../components/UrlList";

const Home = () => {
    const [updateList, setUpdateList] = useState(false);

    const refreshUrls = () => {
        setUpdateList(!updateList);
    };

    return (
        <div className="min-h-screen w-full flex flex-col items-center justify-center py-10 px-4">
            <h1 className="text-4xl font-extrabold text-blue-400 mb-8 drop-shadow-md">
                Acortador de URLs 
            </h1>
            <ShortenUrlForm onUrlShortened={refreshUrls} />
            <div className="mt-6 w-full max-w-4xl">
                <UrlList key={updateList} />
            </div>
        </div>
    );
};

export default Home;


